import * as Yup from 'yup';

const passwordRegEx = /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*)$/;
const passwordTrimmedRegEx = /^[\S]+.*[\S]+$/;
const bannedSpecialCharactersRegEx = /^[a-z\d\-'\s]+$/i;
const emailRegEx = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;

const Register = Yup.object().shape({
  email: Yup.string()
    .email()
    .matches(emailRegEx, 'Email must be a valid email address')
    .required('Email is required'),
  firstName: Yup.string()
    .matches(bannedSpecialCharactersRegEx, 'Name cannot contain special characters')
    .min(2, 'Name must contain at least 2 characters and')
    .max(50, 'Must be less than 50 characters')
    .required('Name required'),
  businessName: Yup.string()
    .matches(bannedSpecialCharactersRegEx, 'Business name cannot contain special characters')
    .min(3, 'Business name should be between 3-50 characters')
    .max(50, 'Must be less than 50 characters')
    .required('Business name required'),
  country: Yup.string().required('Please select a country from the list').nullable(),
  password: Yup.string()
    .matches(passwordRegEx, 'Password must contain a lower and upper case character and number')
    .matches(passwordTrimmedRegEx, 'Password must not start or end with a whitespace character')
    .min(8, 'Password must contain at least 8 characters')
    .required('Password is required'),
  industryCode: Yup.string().required('Industry is required').nullable(),
  companySize: Yup.string().required('Company size is required').nullable(),
});

const RegisterAcceptInvitation = Yup.object().shape({
  email: Yup.string()
    .email()
    .matches(emailRegEx, 'Email must be a valid email address')
    .required('Email is required'),
  firstName: Yup.string()
    .matches(bannedSpecialCharactersRegEx, 'Name cannot contain special characters')
    .min(2, 'Name must contain at least 2 characters and')
    .max(50, 'Must be less than 50 characters')
    .required('Name required'),
  password: Yup.string()
    .matches(passwordRegEx, 'Password must contain a lower and upper case character and number')
    .matches(passwordTrimmedRegEx, 'Password must not start or end with a whitespace character')
    .min(8, 'Password must contain at least 8 characters')
    .required('Password is required')
});

const LoginAcceptInvitation = Yup.object().shape({
  password: Yup.string().required('Password is required'),
});

const Login = Yup.object().shape({
  email: Yup.string()
    .matches(emailRegEx, 'Email must be a valid email address')
    .required('Email is required'),
  password: Yup.string().required('Password is required'),
});

const validationSchema = {
  Register,
  RegisterAcceptInvitation,
  Login,
  LoginAcceptInvitation,
};

export { validationSchema, emailRegEx };
